import { useTranslation } from 'react-i18next'

import { useHealth } from '../api'

/**
 * Bandeau « environnement de test », sur toutes les pages — public, admin, ops.
 *
 * L'environnement de test tourne sur une copie de la production : mêmes
 * visages, mêmes noms, mêmes commandes. Sans marque visible, un onglet ouvert
 * sur le test se confond avec le vrai site, et l'on « rembourse » une commande
 * en croyant répéter — ou l'inverse.
 *
 * Affiché pour `staging` seulement. Ni en production, évidemment, ni sur un
 * poste de développement (`local`) : sa base n'est pas une copie de la
 * production, et le bandeau y mentirait. Tant que la réponse n'est pas
 * arrivée — ou si elle n'arrive pas — rien ne s'affiche : une sonde en échec
 * ne doit pas couvrir le site.
 *
 * `pointer-events-none` : le bandeau recouvre le haut des en-têtes, il ne doit
 * jamais intercepter le geste destiné au bouton du dessous.
 */
export function EnvironmentBanner() {
  const { t } = useTranslation()
  const environment = useHealth().data?.environment

  if (!environment || environment === 'production' || environment === 'local') return null

  return (
    <div
      role="status"
      className="pointer-events-none fixed inset-x-0 top-0 z-[90] bg-[repeating-linear-gradient(135deg,#f59e0b_0_12px,#fbbf24_12px_24px)] px-3 py-0.5 text-center text-[10px] font-bold uppercase leading-tight tracking-wide text-black shadow-md sm:text-xs"
    >
      {t('testEnv.banner')}
    </div>
  )
}
